module.exports = __webpack_public_path__ + "img/11.b3d4ded8.png";